<script>
import {useAdminCommonStore} from '~/store/admin-common/index.js'

export default {
  name: 'ShoppingCartFill',
  props: {
    notification: {
      type: Object,
      default: () => ({
        count: 0,
        list: []
      })
    }
  },
  setup() {
    const adminCommonStore = useAdminCommonStore()
    return {adminCommonStore}
  },
  data() {
    return {
      dropdownVisible: false
    }
  },
  computed: {
    count() {
      return this.notification.count
    },
    list() {
      return this.notification.list
    }
  },
  methods: {
    onClickFooter() {
      this.dropdownVisible = false
      this.$router.push('/admin/management?menu=1&subMenu=0')
    },
    async onClickItem(item) {
      await this.adminCommonStore.putNotification({notificationId : item.id})
      this.dropdownVisible = false
      this.$router.push(`/admin/management/payment/${item.targetId}`)
      // emit으로 reload 호출
      this.$emit('reload')
    },
    async toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
    },
  }
}
</script>

<template>
  <div class="icon-wrap">
    <div class="icon" @click="toggleDropdown">
      <div class="is-12m badge">{{ count }}</div>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 9H19.938L20.438 7H8V5H21.72C21.872 5 22.022 5.03466 22.1586 5.10134C22.2952 5.16801 22.4148 5.26495 22.5083 5.38479C22.6019 5.50462 22.6668 5.6442 22.6983 5.79291C22.7298 5.94162 22.7269 6.09555 22.69 6.243L20.19 16.243C20.1358 16.4592 20.011 16.6512 19.8352 16.7883C19.6595 16.9255 19.4429 17 19.22 17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16V4H2V2H5C5.26522 2 5.51957 2.10536 5.70711 2.29289C5.89464 2.48043 6 2.73478 6 3V9ZM6 23C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21C4 20.4696 4.21071 19.9609 4.58579 19.5858C4.96086 19.2107 5.46957 19 6 19C6.53043 19 7.03914 19.2107 7.41421 19.5858C7.78929 19.9609 8 20.4696 8 21C8 21.5304 7.78929 22.0391 7.41421 22.4142C7.03914 22.7893 6.53043 23 6 23ZM18 23C17.4696 23 16.9609 22.7893 16.5858 22.4142C16.2107 22.0391 16 21.5304 16 21C16 20.4696 16.2107 19.9609 16.5858 19.5858C16.9609 19.2107 17.4696 19 18 19C18.5304 19 19.0391 19.2107 19.4142 19.5858C19.7893 19.9609 20 20.4696 20 21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23Z"
          fill="#606060"
        />
      </svg>
    </div>
    <div v-if="dropdownVisible" class="dropdown-wrap">
      <div class="is-16m dropdown-header">최근 결제내역</div>
      <div class="dropdown-content">
        <div v-if="list.length > 0">
          <div v-for="(item, index) in list" :key="index" :class="['dropdown-item', {read : item.isRead}]" @click="onClickItem(item)">
            <div class="item-content">
              <div class="item-content__title">
                <div class="is-14m title">결제 상품</div>
                <div class="is-14m value">{{ item.title }}</div>
              </div>
              <div class="item-content__title">
                <div class="is-14m title">회원</div>
                <div class="is-14m value">{{ item.subtitle }}</div>
              </div>
              <div class="item-content__content">
                <div class="is-14m title">결제금액</div>
                <div class="is-14m value">
                  <div>{{ item.content }}</div>
                </div>
                <div class="is-14m time-wrap">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3062_17137)">
                      <path
                        d="M7.99992 15.1673C4.31792 15.1673 1.33325 12.1827 1.33325 8.50065C1.33325 4.81865 4.31792 1.83398 7.99992 1.83398C11.6819 1.83398 14.6666 4.81865 14.6666 8.50065C14.6666 12.1827 11.6819 15.1673 7.99992 15.1673ZM7.99992 13.834C9.41441 13.834 10.771 13.2721 11.7712 12.2719C12.7713 11.2717 13.3333 9.91514 13.3333 8.50065C13.3333 7.08616 12.7713 5.72961 11.7712 4.72941C10.771 3.72922 9.41441 3.16732 7.99992 3.16732C6.58543 3.16732 5.22888 3.72922 4.22868 4.72941C3.22849 5.72961 2.66659 7.08616 2.66659 8.50065C2.66659 9.91514 3.22849 11.2717 4.22868 12.2719C5.22888 13.2721 6.58543 13.834 7.99992 13.834ZM8.66658 8.50065H11.3333V9.83398H7.33325V5.16732H8.66658V8.50065Z"
                        fill="#909090"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3062_17137">
                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>{{ item.createdAtText }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="is-14m dropdown-item">최근 7일 내역이 없습니다.</div>
        </div>
      </div>
      <div class="is-16m dropdown-footer" @click="onClickFooter">모든 결제내역 보기</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.icon-wrap {
  position: relative;

  .icon {
    cursor: pointer;

    .badge {
      position: absolute;
      top: -10px;
      right: -8px;
      border-radius: 32px;
      width: 24px;
      background: #0058aa;
      color: white;
      text-align: center;
      padding: 0 2px;
    }
  }

  .dropdown-wrap {
    position: absolute;
    top: 40px;
    right: -20px;
    width: 300px;
    background: white;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    .dropdown-header {
      color: white;
      padding: 8px 16px;
      background: #002063;
    }

    .dropdown-content {
      max-height: 400px;
      overflow-y: auto;
    }

    .dropdown-footer {
      cursor: pointer;
      border-top: 1px solid var(--cnsl-gray-200, #e6e6e6);
      background: var(--cnsl-white, #fff);
      color: #0058aa;
      padding: 8px 16px;
      text-align: center;
    }

    .dropdown-item {
      cursor: pointer;
      padding: 12px 16px;
      border-bottom: 1px solid #f2f2f2;

      &:last-child {
        border-bottom: none;
      }

      .item-content {
        .item-content__title {
          display: flex;
          gap: 8px;

          .title {
            min-width: 55px;
            color: #909090;
          }

          .value {
            .time-wrap {
              display: flex;
              gap: 4px;
              align-items: center;
              color: #909090;
            }
          }
        }

        .item-content__content {
          display: flex;
          gap: 8px;
          align-items: center;

          .title {
            min-width: 55px;
            color: #909090;
          }

          .value {
            color: #0058aa;
          }

          .time-wrap {
            margin-left: auto;
            display: flex;
            gap: 4px;
            align-items: center;
            color: #909090;
          }
        }
      }

      &.read {
        background-color: #E1E1E1;
      }
    }
  }
}
</style>
